import React from 'react';
import { CountTranslation } from '@prisjakt/ui-rating/src/types';
import StoreLogo from '@prisjakt/ui-store-logo';
import shallowEqual from 'shallowequal';

import RatingSmiley from '../rating-smiley';

import { Store } from '../../../../types';
import { Rating } from '../../../../../components/rating/src/types';

import * as S from './styles';

type OwnProps = {
  store: Store;
  showPriceListRatingExperiment: boolean;
  rating?: Rating;
  hide?: boolean;
};

const countTranslation = {
  domain: 'product',
  key: 'prices.n-ratings',
} as CountTranslation;

const StoreInfoColumn = React.memo(
  ({ store, showPriceListRatingExperiment, rating, hide }: OwnProps) => {
    const getRatingCount = () => {
      if (!store.userReviewSummary.countTotal) return null;
      return store.userReviewSummary.countTotal >= 500
        ? '500+'
        : store.userReviewSummary.countTotal;
    };

    const renderRating = () => {
      // return baseline
      return (
        <S.Rating
          hide={store.userReviewSummary.count === 0}
          size="small"
          secondaryColors={!store.featured}
          count={store.userReviewSummary.countTotal}
          countTranslation={countTranslation}
          rate={store.userReviewSummary.rating}
          showCounter={false}
          showPriceListRatingExperiment={showPriceListRatingExperiment}
        />
      );
    };

    return (
      <S.StoreInfo>
        <S.StoreInfoTitle>{store.name}</S.StoreInfoTitle>
        <StoreLogo
          name={store.name}
          storeId={store.id}
          featured={Boolean(store.featured)}
          hasImage={Boolean(store.hasLogo)}
          variant={S.VARIANTS.PRICE_LIST}
        />
        <S.RatingWrapper
          showPriceListRatingExperiment={showPriceListRatingExperiment}
        >
          {rating && rating.whole > 0 && (
            <S.RatingContainer
              data-rating={rating.roundedString}
              showPriceListRatingExperiment={showPriceListRatingExperiment}
            >
              {renderRating()}
              {!hide && (
                <>
                  <RatingSmiley
                    featured={Boolean(store.featured)}
                    rating={rating}
                    scoreVisibility="row"
                    showPriceListRatingExperiment={
                      showPriceListRatingExperiment
                    }
                    size="small"
                  />
                  {showPriceListRatingExperiment ? (
                    <S.RatingCount>{`(${getRatingCount()})`}</S.RatingCount>
                  ) : null}
                </>
              )}
            </S.RatingContainer>
          )}
        </S.RatingWrapper>
      </S.StoreInfo>
    );
  },
  (prevProps, nextProps) => {
    const { store: prevStore, ...prevRest } = prevProps;
    const { store: nextStore, ...nextRest } = nextProps;
    const {
      name: prevName,
      hasLogo: prevHasLogo,
      featured: prevFeatured,
      userReviewSummary: prevUserReviewSummary,
    } = prevStore;
    const {
      name: nextName,
      hasLogo: nextHasLogo,
      featured: nextFeatured,
      userReviewSummary: nextUserReviewSummary,
    } = nextStore;
    return (
      shallowEqual(prevRest, nextRest) &&
      prevUserReviewSummary === nextUserReviewSummary &&
      prevName === nextName &&
      prevHasLogo === nextHasLogo &&
      prevFeatured === nextFeatured
    );
  }
);

export default StoreInfoColumn;
